// removed by extract-text-webpack-plugin
module.exports = {"logoIcon":"Logo__logoIcon-3lyNe"};